import React from "react";
import { formatClaimLanguage } from "./claimViewUtils";
import ClaimQuestionViewOnly from "./ClaimQuestionViewOnly";

const ClaimFormViewOnly = ({ claimDetail = {} }) => {
  const formQuestions = claimDetail?.formData || [];
  const languageLabel = formatClaimLanguage(claimDetail?.language);

  return (
    <>
      <div className="product-view-info mb-30">
        <div className="product-view-info-field">
          <p className="product-view-info-label">Claim Name</p>
          <p className="product-view-info-value">{claimDetail?.claimName || "-"}</p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Claim Type</p>
          <p className="product-view-info-value">Form</p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Language</p>
          <p className="product-view-info-value">{languageLabel}</p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Claim Status</p>
          <p className="product-view-info-value">
            {claimDetail?.claimStatus || "-"}
          </p>
        </div>
      </div>

      <div className="sectionpadding bg-white mb-30 claim-form-view-only-panel">
        <p className="claim-form-view-only-title mb-0">
          Form - For {languageLabel}
        </p>
        <hr className="my-3" />
        <div className="claim-form-view-only-field mb-4">
          <p className="claim-form-view-only-label">Form Title</p>
          <p className="claim-form-view-only-value mb-0">
            {claimDetail?.formTitle || "-"}
          </p>
        </div>
        <div className="claim-form-view-only-field">
          <p className="claim-form-view-only-label">Form Description</p>
          <p className="claim-form-view-only-value mb-0">
            {claimDetail?.formDescription || "-"}
          </p>
        </div>
      </div>

      {formQuestions.length > 0 ? (
        <ClaimQuestionViewOnly questions={formQuestions} />
      ) : (
        <div className="sectionpadding bg-white mb-30 claim-form-view-only-panel">
          <p className="release-document-view-empty mb-0">No questions available.</p>
        </div>
      )}
    </>
  );
};

export default ClaimFormViewOnly;
